export const BIOMETRIC_CALLBACK_SAVE_TOKEN = "SAVE_TOKEN";
export const BIOMETRIC_CALLBACK_UNLOCK_TOKEN = "UNLOCK_TOKEN";
export const BIOMETRIC_CALLBACK_UNLOCK_MORPHOLOGY_TOKEN = "UNLOCK_MORPHOLOGY_TOKEN";
export const AUTHENTICATOR_TOKEN = "TOKEN";
